export { default } from "./StarRating";
